import { Box, Chip, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import PersonIcon from "@mui/icons-material/Person";
import { IUser } from "src/Shared/Interfaces";

export const userColumns = (
  onImpersonate: (user: IUser) => void
): GridColDef[] => {
  return [
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1.5,
      minWidth: 180,
      sortable: false,
      valueGetter: (params) => {
        return `${params.row.firstName || ""} ${params.row.lastName || ""}`.trim();
      },
    },
    {
      field: "emailAddress",
      headerName: "Email Address",
      flex: 2,
      minWidth: 200,
      sortable: false,
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <Chip
            label={params.row.role}
            color="primary"
            variant="outlined"
            size="small"
          />
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={params.row.isActive ? "Active" : "Inactive"}
          sx={{
            backgroundColor: params.row.isActive ? "#4caf50" : "#f44336",
            color: "#fff",
            fontWeight: 500,
          }}
          size="small"
        />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.8,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        const user = params.row as IUser;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <IconButton
              size="small"
              onClick={() => onImpersonate(user)}
              sx={{
                backgroundColor: "#2c3e50",
                color: "#ffffff",
                width: 30,
                height: 30,
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "#1a252f",
                  transform: "scale(1.1)",
                },
              }}
            >
              <PersonIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        );
      },
    },
  ];
};
